import { ValidatorFn } from '@angular/forms';

export interface CountryConfiguration {
  code: string;
  alpha2: string;
  locale: string;
  phonePrefix: string;
  phoneMask: string;
  phonePlaceholder: string;
  documentType: string;
  documentMask: string;
  documentPlaceholder: string;
  documentValidator: ValidatorFn;
}

export const FALLBACK_PHONE_MASK = '';
export const FALLBACK_DOCUMENT_MASK = '';
